import React from "react";
import "./Payment.css";
import { useDispatch, useSelector } from "react-redux";

import { db } from "../firebase";
import ProductItem from "./ProductItem";
import CurrencyFormat from "react-currency-format";
import { useStripe, CardElement, useElements } from "@stripe/react-stripe-js";
import { useHistory } from "react-router-dom";
import axios from "axios";
import { clearCart } from "../redux/cartSlice";

function Payment() {
	const dispatch = useDispatch();

	const basket = useSelector((state) => state.cart.basket);
	const userEmail = useSelector((state) => state.user.user);
	// const [address, setAddress] = useState();

	// // console.log(db.collection("users").collection(userEmail).collection("user-info").document("register-settings"))

	// useEffect(() => {
	// 	console.log(db.collection("users").doc(userEmail).collection("user-info").doc("register-settings"));
	// }, []);

	const history = useHistory();
	const stripe = useStripe();
	const elements = useElements();
	const [error, setError] = React.useState(null);
	const [disabled, setDisabled] = React.useState(true);
	const [processing, setProcessing] = React.useState(false);
	const [succeeded, setSucceeded] = React.useState(false);

	const totalAmount = useSelector((state) => state.total.total);

	const handleSubmit = async (e) => {
		e.preventDefault();

		const { error, paymentMethod } = await stripe.createPaymentMethod({
			type: "card",
			card: elements.getElement(CardElement),
		});

		if (!error) {
			setProcessing(true);
			try {
				const { id } = paymentMethod;
				const response = await axios.post(
					"https://us-central1-clone-28cfc.cloudfunctions.net/api/payment",
					{
						amount: parseInt(totalAmount * 100),
						id,
					}
				);

				if (response.data.success) {
					db.collection("users")
						.doc(userEmail)
						.collection("orders")
						.doc(id)
						.set({
							basket: basket,
							total: totalAmount,
							created: new Date(),
						});

					setSucceeded(true);
					dispatch(clearCart());

					history.push("/orders");
				}
			} catch (error) {
				setProcessing(false);
				alert("You must sign in");
			}
		} else {
			setDisabled(true);
		}
	};

	const handleChange = async (e) => {
		setDisabled(e.empty);
		setError(e.error ? e.error.message : "");
	};

	return (
		<div className="payment">
			<div className="title">
				<h1>
					{" "}
					Checkout <span> {basket.length} </span> items
				</h1>
			</div>

			<div className="payment-container">
				<div className="payment-section">
					<div className="payment-title">
						{" "}
						<h3> Delivery Address </h3>
					</div>
					<div className="payment-address">
						<p>{userEmail}</p>
						<p>80 Waverly Circle</p>
						<p>Watervliet NY, 12189</p>
					</div>
				</div>

				<div className="payment-section">
					<div className="payment-title">
						<h3> Review Your Items </h3>
					</div>
					<div className="payment-items">
						{basket.map((item) => (
							<ProductItem
								id={item.id}
								image={item.image}
								title={item.title}
								price={item.price}
								rating={item.rating}
								hideButton={false}
							/>
						))}
					</div>
				</div>
				<div className="payment-section">
					<div className="payment-title">
						<h3> Payment Method </h3>
					</div>
					<div className="payment-details">
						<form onSubmit={handleSubmit}>
							<CardElement onChange={handleChange} />
							<div className="payment-priceContainer">
								<CurrencyFormat
									renderText={(value) => (
										<>
											<p>
												Order Total: <strong>${totalAmount.toFixed(2)}</strong>
											</p>
										</>
									)}
									decimalScale={2}
									thousandSeparator={true}
									displayType={"text"}
									prefix={"$"}
								/>

								<button disabled={processing || disabled}>
									<span>{processing ? "Processing" : "Buy Now"}</span>
								</button>
								{error && <div>{error}</div>}
							</div>
						</form>
					</div>
				</div>
			</div>
		</div>
	);
}

export default Payment;
